var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBridgeProcessStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_214_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 157H330C330 93 252.171 93 252.171 93C170 93 170 157 170 157H50",
    stroke: "#53EBEF",
    strokeWidth: 40
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450 157H330C330 93 252.171 93 252.171 93C170 93 170 157 170 157H50",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226 142.458L238.6 156.792L274 126",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: 66
  }, /*#__PURE__*/React.createElement("animate", {
    id: "glitterCheckAnimationStart",
    attributeName: "stroke-dashoffset",
    from: 66,
    to: 0,
    dur: "500ms",
    begin: "0s;glitterCheckAnimationEnd.end",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "glitterCheckAnimationEnd",
    attributeName: "stroke-dashoffset",
    from: 0,
    to: -66,
    dur: "500ms",
    begin: "glitterCheckAnimationStart.end+500ms",
    fill: "freeze"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_214_2",
    x: -10,
    y: 13,
    width: 520,
    height: 224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_214_2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeProcessStatus);
export default __webpack_public_path__ + "static/media/bridgeProcessStatus.40e9cdb9.svg";
export { ForwardRef as ReactComponent };